import(/* webpackMode: "eager" */ "/home/runner/work/simpeltransport.se/simpeltransport.se/src/app/error.tsx");
